import { ApplicationConfig, HeaderV2 } from './payload-types'
import qs from 'querystring'

export type Uri = {
  uri: string
  url: string
  localizedTitle?: string
  entityLabel: string
}

export class PayloadApiClient {
  private baseURL: string

  private locale: string

  constructor(options: { baseURL: string; locale: string }) {
    this.baseURL = options.baseURL
    this.locale = options.locale
  }

  async request<Data>(
    endpoint: string,
    options?: {
      params?: any
    },
  ) {
    let url = `${this.baseURL}${endpoint}`
    if (options?.params) {
      url += `?${qs.stringify(options.params)}`
    }
    const response = await fetch(`${this.baseURL}${endpoint}`, {
      headers: {
        Store: this.locale,
      },
    })
    if (!response.ok) {
      throw new Error(`Failed to fetch ${url}`, {
        cause: response,
      })
    }
    const data = await response.json()
    return data as Data
  }

  getHeaderV2() {
    return this.request<HeaderV2>('/globals/header_v2')
  }

  getApplicationConfig() {
    return this.request<ApplicationConfig>('/globals/application_config')
  }

  resolveUriList(input: { uriList: string[] }) {
    return this.request<Uri[]>(`/uri-router/resolve?input=${JSON.stringify(input)}`)
  }
}
